import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const expandableStatisticsComponentStyles = makeStyles((theme: Theme) =>
    createStyles({
        component: {
            marginLeft: "10px",
            marginRight: "20px",
            backgroundColor: "rgba(39, 10, 220, 0.00)",
        },
        text: { marginTop: "15px", fontSize: 16 },
        title: { fontSize: 18, marginBottom: "5px" },
        unitsFont: { fontWeight: 400, float: "right" },

        loadingIndicator: {
            width: 135,
            paddingTop: 30,
        },
    })
);
